export default __webpack_public_path__ + "static/media/timer.c8fbecf3.svg";